import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loader from "../../../core/common/loader";
import CommonSelect from "../../../core/common/commonSelect";
import api from "../../../services/api";
import { showBasicAlert } from "../../../core/common/useAlert";
import "./crm-setting.css";

const CrmSettings = () => {
  const signature = localStorage.getItem("signature");
  const [isLoading, setIsLoading] = useState(false);
  const [companyList, setCompanyList] = useState<any[]>([]);
  const [leadSettings, setLeadSettings] = useState({
    lead_expire_day: 0,
    lead_re_assign_day: 0,
    lead_assigned_to_department: "",
  });
  const [selectedCompany, setSelectedCompany] = useState({
    companyId: "",
    companyName: "Select Company",
    companyType: "",
  });
  const [getAllDpertment, setgetAllDesignations] = useState<any[]>([]);

  const departmentOptions = [
    ...getAllDpertment.map((department) => ({
      value: department.key,
      label: department.Department,
    })),
  ];

  useEffect(() => {
    fetchCompanyList();
  }, []);

  const fetchCompanyList = async () => {
    setIsLoading(true);
    try {
      const [response, getDesignation] = await Promise.all([
        api.post("userService/getAllCompanyList", {
          signature,
        }),
        api.post("userService/getDepartment", { signature }),
      ]);
      setCompanyList(response.data.data.data);
      setgetAllDesignations(getDesignation.data.data.data);
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
    setIsLoading(false);
  };

  const handleCompanyChange = async (selectedOption: any) => {
    if (!selectedOption) return;

    setIsLoading(true);
    setLeadSettings({
      lead_expire_day: 0,
      lead_re_assign_day: 0,
      lead_assigned_to_department: "",
    });

    const newCompany = {
      companyId: selectedOption.value,
      companyName: selectedOption.label.split("-")[0].trim(),
      companyType: selectedOption.label.split("-")[1].trim(),
    };

    setSelectedCompany(newCompany);

    try {
      // Fetch lead settings
      const leadResponse = await api.post("leadService/getAllLeadSettings", {
        signature,
        company_id: newCompany.companyId,
        company_type: newCompany.companyType,
      });

      // Set lead settings
      if (leadResponse.data.data.data) {
        const fetchedLeadSettings =
          leadResponse.data.data.data[0].settings || {};
        setLeadSettings({
          lead_expire_day: fetchedLeadSettings.lead_expire_day || 0,
          lead_re_assign_day: fetchedLeadSettings.lead_re_assign_day || 0,
          lead_assigned_to_department:
            fetchedLeadSettings.lead_assigned_to_department || "",
        });
      }
    } catch (error: any) {
      console.error("Error fetching lead settings:", error);
    }
    setIsLoading(false);
  };

  const handleLeadInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setLeadSettings((prevSettings) => ({
      ...prevSettings,
      [name]: value,
    }));
  };

  const handleDesignationChange = (selectedOption: any) => {
    if (!selectedOption) return;
    setLeadSettings((prevSettings) => ({
      ...prevSettings,
      lead_assigned_to_department: selectedOption.value,
    }));
  };

  const handleUpdateLeadSettings = async () => {
    setIsLoading(true);
    try {
      const response = await api.post("leadService/updateLeadSettings", {
        signature,
        company_id: selectedCompany.companyId,
        company_type: selectedCompany.companyType,
        settings: leadSettings,
      });
      showBasicAlert(response.data.message[0].msg);
    } catch (error: any) {
      showBasicAlert(error.data.message[0].msg);
    }
    setIsLoading(false);
  };

  return (
    <>
      {isLoading && <Loader />}

      <div className="page-wrapper">
        <div className="content">
          <div className="card shadow-sm border-0">
            <div className="card-body px-4 py-4">
              <h4 className="fw-semibold mb-4 text-primary">CRM Settings</h4>

              <div className="mb-4">
                <label className="form-label fw-medium mb-2">
                  Select Company
                </label>
                <CommonSelect
                  options={companyList.map((company) => ({
                    value: company.id,
                    label: `${company.name} - ${company.type}`,
                  }))}
                  defaultValue={{
                    value: selectedCompany.companyId,
                    label: `${selectedCompany.companyName} - ${selectedCompany.companyType}`,
                  }}
                  onChange={handleCompanyChange}
                />
              </div>

              {selectedCompany.companyId && (
                <div className="bg-light rounded p-4 border mt-3">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Lead Expire Day</label>
                      <input
                        type="number"
                        className="form-control"
                        name="lead_expire_day"
                        value={leadSettings.lead_expire_day}
                        onChange={handleLeadInputChange}
                        placeholder="Enter expire day"
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label">Lead Re-Assign Day</label>
                      <input
                        type="number"
                        className="form-control"
                        name="lead_re_assign_day"
                        value={leadSettings.lead_re_assign_day}
                        onChange={handleLeadInputChange}
                        placeholder="Enter re-assign day"
                      />
                    </div>

                    <div className="col-md-12 mb-3">
                      <label className="form-label">
                        Lead Assigned to Department
                      </label>
                      <CommonSelect
                        options={departmentOptions}
                        defaultValue={departmentOptions.find(
                          (option) =>
                            option.value ===
                            leadSettings.lead_assigned_to_department
                        )}
                        onChange={handleDesignationChange}
                      />
                    </div>

                    <div className="col-12 text-end mt-2">
                      <button
                        className="btn btn-primary px-4"
                        onClick={handleUpdateLeadSettings}>
                        Update Lead Settings
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © CMS.</p>
          <p>
            Designed & Developed By{" "}
            <Link
              to="#"
              onClick={(e: any) => e.preventDefault()}
              className="text-primary fw-medium">
              ZYVO
            </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default CrmSettings;
